//src\components\portal\portal_components\data_manager\data_stats.js
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';

const DataStats = ({ stats }) => {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={6} sm={2.4}>
        <Box textAlign="center" sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="h6" color="primary">{stats.total}</Typography>
          <Typography variant="body2">Total Pages</Typography>
        </Box>
      </Grid>
      <Grid item xs={6} sm={2.4}>
        <Box textAlign="center" sx={{ p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
          <Typography variant="h6" sx={{ color: '#1976d2' }}>{stats.sites}</Typography>
          <Typography variant="body2">Site Pages</Typography>
        </Box>
      </Grid>
      <Grid item xs={6} sm={2.4}>
        <Box textAlign="center" sx={{ p: 2, backgroundColor: '#e8f5e8', borderRadius: 1 }}>
          <Typography variant="h6" sx={{ color: '#388e3c' }}>{stats.docs}</Typography>
          <Typography variant="body2">Documents</Typography>
        </Box>
      </Grid>
      <Grid item xs={6} sm={2.4}>
        <Box textAlign="center" sx={{ p: 2, backgroundColor: '#ffebee', borderRadius: 1 }}>
          <Typography variant="h6" sx={{ color: '#d32f2f' }}>{stats.toRemove}</Typography>
          <Typography variant="body2">To Remove</Typography>
        </Box>
      </Grid>
      <Grid item xs={6} sm={2.4}>
        <Box textAlign="center" sx={{ p: 2, backgroundColor: '#fff3e0', borderRadius: 1 }}>
          <Typography variant="h6" sx={{ color: '#f57c00' }}>{stats.toAdd}</Typography>
          <Typography variant="body2">To Add</Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DataStats;